import { gql } from '@apollo/client'

export const GQL_QUERY_LANDING_PAGE = gql`
  query LandingPage($code: String, $id: ID) {
    landingPage(code: $code, id: $id) {
      id
      code
      name
      kind
      stateId
      header {
        showHeader
        hero {
          type
          bannerId
          storyId
          payload
        }
      }
      actions {
        id
        type
        payload
        target {
          kind
          contestId
          contestCode
          textMaterialId
          textMaterialSlug
          screen
          url
          params
        }
      }
      blocks {
        id
        type
        subtype
        order
        visibleForStates
        payload
        target {
          kind
          contestId
          contestCode
          textMaterialId
          textMaterialSlug
          screen
          url
          params
        }
      }
      promo {
        participating
        earnedChances
        usedChances
        availableWheelChances
        contest {
          id
          code
          actionId
        }
      }
    }
  }
`
